class SubscriptionAssetStatus {
    static AwaitingInstallAndCollection : string = "AwaitingInstallAndCollection";
    static CollectedNotInstalled : string = "CollectedNotInstalled";
    static InstalledNotCollected : string = "InstalledNotCollected";
    static InstalledAndCollected : string = "InstalledAndCollected";
    static VehicleOnboarded : string = "VehicleOnboarded";
}

export {SubscriptionAssetStatus}
